import { render, staticRenderFns } from "./VirtualGiftModal.vue?vue&type=template&id=a4a28f6c&"
import script from "./VirtualGiftModal.vue?vue&type=script&lang=js&"
export * from "./VirtualGiftModal.vue?vue&type=script&lang=js&"
import style0 from "./VirtualGiftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports